(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
/* ← tu zostawiasz swój kod z hash scroll */

(() => {
  document.querySelectorAll('.LoadMoreProducts').forEach((btn) => {
    const root    = btn.closest('results-list');
    const grid    = root?.querySelector('ul.product-grid');
    const hideBtn = root?.querySelector('.HideExtraProducts');
    if (!grid) return;

    const firstNextUrl = btn.dataset.nextUrl || '';

    // SHOW MORE
    btn.addEventListener('click', async () => {
      const url = btn.dataset.nextUrl;
      if (!url) return btn.remove();

      btn.disabled = true;
      const txt = btn.textContent;
      btn.textContent = 'Loading...';

      try {
        const res  = await fetch(url, { credentials: 'same-origin' });
        const html = await res.text();
        const doc  = new DOMParser().parseFromString(html, 'text/html');

        // doklejamy i OZNAKOWUJEMY doładowane elementy
        doc.querySelectorAll('ul.product-grid li.product-grid__item')
          .forEach((li) => {
            li.setAttribute('data-loaded', 'extra');
            grid.appendChild(li);
          });

        // pokaż "Hide" po pierwszym doładowaniu
        if (hideBtn) hideBtn.hidden = false;

        // ustaw kolejny URL albo usuń "Show more"
        const nextBtn = doc.querySelector('.LoadMoreProducts');
        btn.dataset.nextUrl = nextBtn?.dataset.nextUrl || '';
        if (!btn.dataset.nextUrl) {
          btn.remove();
        } else {
          btn.disabled = false;
          btn.textContent = txt;
        }
      } catch (e) {
        console.error(e);
        btn.disabled = false;
        btn.textContent = 'Try again';
      }
    });

    // HIDE — usuń WSZYSTKO co było doładowane
    hideBtn?.addEventListener('click', () => {
      grid.querySelectorAll('li[data-loaded="extra"]').forEach((el) => el.remove());

      // przywróć "Show more" i zacznij znów od strony 2
      if (!btn.isConnected) {
        hideBtn.parentElement.insertBefore(btn, hideBtn);
      }
      btn.dataset.nextUrl = firstNextUrl;
      btn.disabled = false;
      btn.textContent = 'Show more';

      // schowaj "Hide" (nie ma już żadnych extra)
      hideBtn.hidden = true;
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-results"]) return;
  try {
    
(() => {
  if (window.__rpgSearchLoadMoreBound) return;
  window.__rpgSearchLoadMoreBound = true;

  document.addEventListener('click', async (event) => {
    const btn = event.target.closest('.SearchLoadMoreProducts');

    if (btn) {
      const root = btn.closest('[section-id]');
      const grid = root?.querySelector('ul.product-grid');
      const hideBtn = root?.querySelector('.SearchHideExtraProducts');

      if (!grid) return;

      const url = btn.dataset.nextUrl;

      if (!url) {
        btn.hidden = true;
        return;
      }

      btn.disabled = true;

      const originalText = btn.textContent;
      btn.textContent = 'Loading...';

      try {
        const response = await fetch(url, {
          credentials: 'same-origin'
        });

        const html = await response.text();

        const doc = new DOMParser().parseFromString(
          html,
          'text/html'
        );

        const sectionId = btn.dataset.sectionId;

        const fetchedSection = doc.getElementById(
          `shopify-section-${sectionId}`
        );

        const fetchedGrid =
          fetchedSection?.querySelector('ul.product-grid');

        if (!fetchedGrid) {
          throw new Error(
            'Nie znaleziono product grid na następnej stronie.'
          );
        }

        const newItems = [
          ...fetchedGrid.querySelectorAll(
            ':scope > li.product-grid__item'
          )
        ];

        newItems.forEach((li) => {
          li.setAttribute('data-loaded', 'extra');
          grid.appendChild(li);
        });

        if (hideBtn && newItems.length) {
          hideBtn.hidden = false;
        }

        const nextBtn =
          fetchedSection.querySelector(
            '.SearchLoadMoreProducts'
          );

        btn.dataset.nextUrl =
          nextBtn?.dataset.nextUrl || '';

        if (!btn.dataset.nextUrl) {
          /* jeśli ostatnia strona — zostaw Collapse,
             ale schowaj Show more */
          btn.hidden = true;
        } else {
          /* jeśli są kolejne strony — zostają oba przyciski */
          btn.hidden = false;
          btn.disabled = false;
          btn.textContent = originalText;
        }
      } catch (error) {
        console.error(error);

        btn.hidden = false;
        btn.disabled = false;
        btn.textContent = 'Try again';
      }

      return;
    }

    const hideBtn = event.target.closest(
      '.SearchHideExtraProducts'
    );

    if (!hideBtn) return;

    const root = hideBtn.closest('[section-id]');
    const grid = root?.querySelector('ul.product-grid');
    const showBtn = root?.querySelector(
      '.SearchLoadMoreProducts'
    );

    grid
      ?.querySelectorAll(
        'li.product-grid__item[data-loaded="extra"]'
      )
      .forEach((el) => el.remove());

    if (showBtn) {
      showBtn.dataset.nextUrl =
        showBtn.dataset.firstNextUrl || '';

      showBtn.hidden = false;
      showBtn.disabled = false;
      showBtn.textContent = 'Show more';
    }

    hideBtn.hidden = true;
  });
})();

  } catch(e) { console.error(e); }
})();
})();
